







import {Vue, Component, Prop, Inject } from 'vue-property-decorator';
import Tabs from './Tabs.vue';
import {Navigation} from '@/types';

@Component({
  name: 'TabNavigator',
  components: {
    Tabs,
  },
})
export default class TabNavigator extends Vue {
  @Prop({type: Array, default: () => []}) public readonly tabs!: Navigation[];

  @Inject() public readonly mapTabs!: object;
}
